import {InlineCode} from '@pinecast/common/Text';
import type * as React from 'react';

// The rich-text tags any message in this repo may wrap text in, so
// `<b>bold</b>` and `<code>literal</code>` render the same wherever a message
// is formatted.
//
// Shared rather than inlined into `Provider` because sites are formatted
// through `createIntl` instead (see ./site.tsx), and a tag that renders one way
// in the dashboard and another way on a website would be a bug nobody goes
// looking for.
export const defaultRichTextElements: Record<
  string,
  (chunks: React.ReactNode) => React.ReactNode
> = {
  b: c => <b>{c}</b>,
  code: c => <InlineCode>{c}</InlineCode>,
};
